import { makeRequestAuth } from "../utils/globals";
/*
 * @param  filters
 * @returns {promise}
 * returns default templates
 */
const defaultEmailTemplates = (params) => {
  return new Promise((resolve, reject) => {
    const request_data = {
      query: "storesAdmin.mutation.default_email_templates",
      tag: "storeAdmin",
      variables: {
        add_data: params,
      },
    };
    makeRequestAuth(request_data, (response) => {
      if (response && response.data) {
        resolve(response.data);
      } else {
        resolve({});
      }
    });
  });
};

/*
 * @param  filters
 * @returns {promise}
 * returns categories and subcategories
 */
const templateCategories = (params) => {
  return new Promise((resolve, reject) => {
    const request_data = {
      query: "storesAdmin.mutation.template_categories",
      tag: "storeAdmin",
      variables: {
        add_data: params,
      },
    };
    makeRequestAuth(request_data, (response) => {
      if (response && response.data) {
        resolve(response.data);
      } else {
        resolve({});
      }
    });
  });
};
export { defaultEmailTemplates, templateCategories };
